/*
 * SMParts — Notbremse fuer den Menue-Drawer
 *
 * Dawn sperrt das Scrollen, solange der Drawer offen ist: der Body
 * bekommt "overflow-hidden-tablet". Weil die Regel am Body haengt und
 * das <html> davor "visible" ist, uebertraegt der Browser sie auf das
 * ganze Fenster — Wischen und Mausrad sind dann tot, waehrend
 * window.scrollTo() aus JavaScript weiterhin funktioniert. Bleibt die
 * Klasse haengen, sieht die Seite deshalb voellig normal aus und
 * reagiert trotzdem nicht. Beim Messen faellt das leicht durch: erst
 * eine echte Wischbewegung zeigt den Fehler.
 *
 * Diese Datei behebt zwei Wege, auf denen die Sperre haengen bleibt.
 *
 * 1) Unser eigenes X neben der Karte
 *
 *    Dawn bindet JEDEN Button innerhalb von <header-drawer> an
 *    onCloseButtonClick, und das ruft closeSubmenu(). Die Funktion ist
 *    fuer Untermenue-Knoepfe geschrieben: sie nimmt "menu-opening" und
 *    "open" weg, aber nicht die Sperre vom Body. Die entfernt nur
 *    closeMenuDrawer(), und das erreicht man ueber den Button nicht.
 *
 *    Wir schliessen deshalb selbst richtig — mit dem <summary> als
 *    Fokusziel, sonst bricht Dawns eigene Ueberschreibung sofort ab
 *    (HeaderDrawer.closeMenuDrawer steigt ohne elementToFocus aus).
 *
 * 2) Der stehengebliebene halbe Zustand
 *
 *    Dawn entfernt "open" erst 400 ms spaeter, gemessen ueber
 *    requestAnimationFrame. Das steht still, sobald die Seite nicht
 *    mehr gezeichnet wird: Tab gewechselt, App gewechselt, Bildschirm
 *    aus. Passiert das mitten im Schliessen, bleibt "open" fuer immer.
 *
 *    Der Waechter unten raeumt beides auf: einen offenen Drawer ohne
 *    "menu-opening" und eine Sperre am Body, zu der kein offener
 *    Drawer mehr gehoert.
 */
(function () {
  var FRIST = 600;
  var SPERREN = ['overflow-hidden-tablet', 'overflow-hidden-mobile', 'overflow-hidden-desktop'];

  /*
   * Andere Bauteile benutzen dieselben Klassen — die Laenderauswahl im
   * Fussbereich zum Beispiel. Solange eines davon offen ist, ist die
   * Sperre berechtigt und wir halten die Finger davon.
   */
  var FREMDE_NUTZER = 'localization-form details[open], .modal__content[open], cart-drawer.active, dialog[open]';

  function sperreLoesen() {
    document.body.classList.remove.apply(document.body.classList, SPERREN);
  }

  function istGesperrt() {
    return SPERREN.some(function (k) {
      return document.body.classList.contains(k);
    });
  }

  function drawerOffen() {
    return !!document.querySelector('header-drawer details[open], menu-drawer details[open]');
  }

  /* ------------------------------------------------ 1) richtig schliessen */

  document.addEventListener('click', function (ereignis) {
    var knopf = ereignis.target.closest && ereignis.target.closest('.smp-drawer-close');
    if (!knopf) return;

    var drawer = knopf.closest('header-drawer, menu-drawer');
    var details = drawer && drawer.querySelector('details');
    var summary = details && details.querySelector('summary');
    if (!details) return;

    if (typeof drawer.closeMenuDrawer === 'function' && summary) {
      drawer.closeMenuDrawer(ereignis, summary);
    } else {
      details.classList.remove('menu-opening');
      details.removeAttribute('open');
    }

    /*
     * Und in jedem Fall die Sperre loesen. Dawn raet den Klassennamen
     * aus data-breakpoint zusammen; steht dort etwas Unerwartetes,
     * bleibt eine Klasse liegen, die niemand mehr entfernt.
     */
    sperreLoesen();
  });

  /* ---------------------------------------------------- 2) Waechter */

  function aufraeumen() {
    document.querySelectorAll('header-drawer details, menu-drawer details').forEach(function (d) {
      if (d.hasAttribute('open') && !d.classList.contains('menu-opening')) {
        d.removeAttribute('open');
      }
    });
    if (istGesperrt() && !drawerOffen() && !document.querySelector(FREMDE_NUTZER)) {
      sperreLoesen();
    }
  }

  var timer = null;

  function anstossen() {
    window.clearTimeout(timer);
    timer = window.setTimeout(aufraeumen, FRIST);
  }

  /*
   * Auf Klassen und Attribute horchen statt in einem Intervall
   * nachzusehen: so laeuft nichts, solange alles in Ruhe ist. Der Body
   * gehoert mit dazu, denn die haengende Sperre ist eine Aenderung an
   * ihm — und genau die soll den Waechter wecken.
   */
  function beobachten() {
    var ziele = [document.body].concat(
      Array.prototype.slice.call(document.querySelectorAll('header-drawer details, menu-drawer details'))
    );
    ziele.forEach(function (ziel) {
      if (ziel.smpNotbremse) return;
      ziel.smpNotbremse = true;
      new MutationObserver(anstossen).observe(ziel, {
        attributes: true,
        attributeFilter: ['class', 'open'],
      });
    });
  }

  /* Beim Zurueckkommen auf die Seite sofort nachsehen: genau dann
     entsteht der halbe Zustand, und der Benutzer schaut gerade hin. */
  document.addEventListener('visibilitychange', function () {
    if (document.visibilityState === 'visible') aufraeumen();
  });

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', beobachten);
  } else {
    beobachten();
  }

  document.addEventListener('shopify:section:load', beobachten);
})();
